import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Link, styled, Switch, Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import { REACT_URL_VISITORACCESSLEVEL } from "../../actions/EndPoints";
import AccessLevelIconGlobal from "../../assets/USA_Images/AccessLevelIconGlobal";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  getPurposeType,
  updatePurposeType,
} from "../../slices/PurposeTypeGlobalUSA/PurposeTypeGlobalSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import FilterChecklistTemplate from "../ChecklistTemplateUSA/FilterChecklistTemplate";
import EditIcon from "../Person/EditIcon";
import PurposeTypeForm from "./PurposeTypeForm";
import PurposeTypeView from "./PurposeTypeView";

export default function PurposeTypeUSA(props) {
  const [clear, setClear] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const [openAccessLevelDialog, setOpenAccessLevelDialog] = useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);

  const Android12Switch = styled(Switch)(({ mode, theme }) => ({
    padding: 8,
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      border: "1px solid #888B8D",
      backgroundColor: mode ? "#888B8D" : "white",
    },
    "& .MuiSwitch-thumb": {
      backgroundColor: "#888B8D",
      boxShadow: "none",
      width: 16,
      height: 16,
      margin: 2,
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: 16,
        height: 16,
      },
    },
    "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
      backgroundColor: "#fff", // Change thumb color when checked
      "&:after": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "60%",
        height: "60%",
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "contain",
      },
    },
    "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#226BAB !important",
      opacity: 1,
    },
  }));

  const [selectedObject, setSelectedObject] = useState({
    id: "",
    name: "",
    companyId: "",
    description: "",
    templateId: "",
  });

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = React.useState({
    name: "",
  });

  const defaultFilter = {
    name: "",
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadData = (filter, paging) => {
    dispatch(getPurposeType(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.curPage);
          setTotalPages(data.data.totalPages);
          setRows(data.data.purposeTypes);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      name: data.name,
    });
  };

  const handlePurposeTypeStatusChange = (event, params) => {
    const updatePurposeTypeData = {
      id: params.id,
      name: params.name,
      description: params.description,
      templateId: params.templateId ? params.templateId.id : params.templateId,
      status: params.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      accessLevelIds: params.accessLevelIds ? params.accessLevelIds : [],
      opType: params.status === "ACTIVE" ? "Disable" : "Enable",
    };
    dispatch(updatePurposeType(updatePurposeTypeData))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0044") {
          loadData(filter, paging);
        }
      });
  };

  const handleEditVisit = (params) => {
    setOpenEditDialog(!openEditDialog);
    setSelectedObject(params);
    setDiaLogBoxBlur(true);
  };

  const handleAccessLevel = (params) => {
    setOpenAccessLevelDialog(!openAccessLevelDialog);
    setSelectedObject(params);
    if (!CommonUtil.isEmptyArray(params.accessLevelIds)) {
      history.push({
        pathname: REACT_URL_VISITORACCESSLEVEL,
        state: { data: params },
      });
    } else {
      Toast(
        t("PURPOSELABELINFO") + " " + params.name + t("PURPOSELABELINFO1"),
        "warning"
      );
      history.push({
        pathname: REACT_URL_VISITORACCESSLEVEL,
        state: { data: params },
      });
    }
  };

  const columns = React.useMemo(() => [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },
    {
      field: "name",
      headerName: t("PURPOSELABEL"),
      flex: 1,
      width: 110,
      renderCell: (params) => (
        <Tooltip title={params.row.name}>
          <span>{params.row.name}</span>
        </Tooltip>
      ),
    },

    {
      field: "templateId",
      headerName: t("CHECKLIST001"),
      flex: 1,
      width: 110,
      renderCell: (params) => (
        <Tooltip title={params.row?.templateId ? params.row.templateId.name : ""}>
          <span>{params.row?.templateId ? params.row.templateId.name : ""}</span>
        </Tooltip>
      ),
    },

    {
      field: "description",
      headerName: t("ATYPE009"),
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Tooltip title={params?.row?.description}>
          <span>{params?.row?.description}</span>
        </Tooltip>
      ),
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 205,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <PurposeTypeView title={t("PURPOSETYPE1")} rowData={params.row} />,
        <Box onClick={() => handleEditVisit(params.row)}>
          <EditIcon />
        </Box>,

        <GridActionsCellItem
          icon={<AccessLevelIconGlobal />}
          label={t("COMMON005")}
          onClick={() => handleAccessLevel(params.row)}
        />,

        <Tooltip
          title={params.row.status === "ACTIVE" ? t("DISABLE") : t("ENABLE")}
        >
          <Android12Switch
            checked={params.row.status === "ACTIVE"}
            onChange={(event) =>
              handlePurposeTypeStatusChange(event, params.row)
            }
            mode={darkMode}
          />
        </Tooltip>,
      ],
    },
  ]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <HeaderToolbar
        title={t("PURPOSETYPE")}
        tooltipTitle={t("VISPURPOSE001")}
      />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        style={{
          gap: "8px",
          padding: "10px 0px 10px 10px",
        }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
        <Tooltip title={t("PURPOSETYPE")}>
          <Box item className={"addIcon"} onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>
        <Box item>
          <FilterChecklistTemplate
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleFilter(data)}
          />
        </Box>

      </Box>
      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
      {open && (
        <PurposeTypeForm
          selectedObject={selectedObject}
          open={open}
          handleClose={() => {
            handleClose(loadData(filter, paging));
            setDiaLogBoxBlur(false);
          }}
        />
      )}
      {openEditDialog && (
        <PurposeTypeForm
          selectedObject={selectedObject}
          open={openEditDialog}
          handleClose={() => {
            setOpenEditDialog(false);
            loadData(filter, paging);
            setDiaLogBoxBlur(false);
            setSelectedObject({
              id: "",
              name: "",
              description: "",
              templateId: "",
            });
          }}
        />
      )}
    </>
  );
}
